import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const ViewSvg = () => (
  <svg width="22" height="14" viewBox="0 0 22 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.8171 6.425C21.6331 6.162 17.2221 0 11.0001 0C4.77809 0 0.367094 6.162 0.183094 6.425C0.063973 6.59326 0 6.79434 0
      7.0005C0 7.20666 0.063973 7.40774 0.183094 7.576C0.367094 7.838 4.77809 14 11.0001 14C17.2221 14 21.6331 7.838 21.8171
      7.576C21.9362 7.40774 22.0002 7.20666 22.0002 7.0005C22.0002 6.79434 21.9362 6.59326 21.8171 6.425ZM11.0001 12C6.83409 12
      3.45109 8.425 2.26909 6.999C3.44809 5.573 6.82009 2 11.0001 2C15.1661 2 18.5491 5.576 19.7311 7.001C18.5521 8.428 15.1801 12 11.0001 12Z"
      fill="currentColor"
    />
    <path
      d="M11 3C8.794 3 7 4.795 7 7C7 9.206 8.794 11 11 11C13.206 11 15 9.206 15 7C15 4.795 13.206 3 11 3ZM11 9C9.897 9 9 8.103 9
      7C9 5.898 9.897 5 11 5C12.103 5 13 5.898 13 7C13 8.103 12.103 9 11 9Z"
      fill="currentColor"
    />
  </svg>
);

const View = (props: IIconProps) => <Icon component={ViewSvg} {...props} />;

export default View;
